import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  beta: true,
  production: false,
  apiUrl: 'https://beta.api.petszel.com/',
  dashboardUrl: 'https://beta.shelter.petszel.com',
  petParentAppUrl: 'https://beta.app.petszel.com/',
  logger: {
    level: NgxLoggerLevel.INFO,
    serverLogLevel: NgxLoggerLevel.ERROR,
    disableConsoleLogging: false,
  },
};
